import 'classlist-polyfill';

import objectFitImages from 'object-fit-images';
import AgeConfirmationModal from './components/layout/ageConfirmationModal';
import navigation from './components/layout/navigation';
import responsiveVideos from './components/layout/responsiveVideos';
import quantitySelect from './components/layout/quantitySelect';
import validation from './components/forms/validation';
import { form } from './components/forms/form';
import cookieNotification from './components/cookies/cookieNotification';
import ModalManager from './components/modals/ModalManager';
import CartModal from './components/cart/cartModal';
import Contact from './pages/Contact';
import Components from './pages/Components';
import CustomersAddresses from './pages/CustomersAddresses';
import Product from './pages/Product';
import accordion from './components/layout/accordion';
import JsonFetcher from './components/layout/JsonFetcher';
import SwiperSlideshow from './components/layout/swiper';
import Disclosure from './components/layout/Disclosure';
import popupModal from './components/modals/popupModal';
import storeLocator from './components/locator/locator';

require('./utils/nativeConsole');

// Set js class
const htmlClassList = document.documentElement.classList;
htmlClassList.add('js');
htmlClassList.remove('no-js');

window.modalManager = new ModalManager();

// Layout setup
navigation();
responsiveVideos();
cookieNotification();
quantitySelect();
accordion();
objectFitImages();
storeLocator();

if (document.getElementById('instagram-feed')) {
  // eslint-disable-next-line no-new
  new JsonFetcher(document.getElementById('instagram-feed'), 'instagram');
}

[...document.querySelectorAll('.swiper-container--caroussel')].forEach(element => {
  // eslint-disable-next-line no-new
  new SwiperSlideshow(element, 'caroussel');
});

[...document.querySelectorAll('.swiper-container--match')].forEach(element => {
  // eslint-disable-next-line no-new
  new SwiperSlideshow(element, 'match');
});

// Forms
validation();

if (document.getElementById('form-newsletter')) {
  form('#form-newsletter');
}
/* if (document.querySelectorAll('.swiper-container')) {
} */

// Popup modal
popupModal();

// Cart
window.cartModal = new CartModal();
// Age conformation
window.ageModal = new AgeConfirmationModal();

// Disclosure
const disclosures = document.querySelectorAll('.disclosure');
disclosures.forEach(el => {
  // eslint-disable-next-line no-new
  new Disclosure(el);
});

// Enable this if you want to test ga calls in development
// gaDevelopment();

// Page specific classes
const pages = {
  Contact,
  Components,
  CustomersAddresses,
  Product,
};

// Get page class from template datapage
const currentPage = `-${document.documentElement.getAttribute('data-page')}`;
if (currentPage) {
  const pageClassName = currentPage.split('-').reduce((accumulator, currentValue) => {
    return accumulator + currentValue.charAt(0).toUpperCase() + currentValue.slice(1);
  });

  if (pageClassName !== '' && typeof pages[pageClassName] === 'function') {
    new pages[pageClassName](); // eslint-disable-line no-new
  }
}

window.modalManager.checkModalOnPageLoad();
